import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import CardCurrentWeatherConditions from './CardCurrentWeatherConditions';
import ForecastChart from './ForecastChart';
import TideChart from './TideChart';
import { makeStyles } from '@material-ui/core/styles';
import CardCurrentConditions from './CardCurrentConditions';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import WeatherWeek from '../weather/WeatherWeek';
import BuoyForecastIcon from '@mui/icons-material/Timeline';
import Collapse from '@mui/material/Collapse';
import React, { useState } from 'react';
import Icon from '@mui/icons-material/SmartToy';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: 0,
        padding: 15,
        backgroundColor: 'rgba(5,4,2,0.1)',
    
    },
    card: {
        padding: theme.spacing(2),
    },
    sectionBlack: {
        padding: theme.spacing(2),
        backgroundColor: 'rgba(4, 3, 2, 0.7)',
        linearggradient: (
            'rgba(0, 0, 0, 0.7)', 
            'rgba(0, 0, 0, 0.7)'
          ),
    },
    section: {
        height: "100%",
        paddingTop: 1,
        backgroundColor: 'rgba(5,4,2,0.1)',
    },
    title: {
        marginBottom: 16,
        fontSize: 18,
    },
}));

const Forecast = ({forecast , waveStationForecast, waveStationRealtime, waterLevel, weather, weatherWeek, spotWaveConditions, videos}) => {

    const [expanded, setExpanded] = useState(false);
    const [aiSectionText, setAiSectionText] = useState("See AI waves analysis");

    const handleExpandClick = () =>{ 
        setExpanded(!expanded);
        (expanded) ? setAiSectionText("See AI waves analysis") : setAiSectionText("Hide AI waves analysis");
    }

    const history = useHistory();

    const classes = useStyles();   

    const redirectToBuoysForeCast = () =>{ 
        let path = `buoys-forecast/`; 
    
        history.push(path);
    }

    const formatDate = (value) => {
        const date = new Date(value)
    
        const formattedDate = date.toLocaleString("en-US", {})
    
        return formattedDate;
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                    <Card className={classes.section}>
                        <CardMedia
                        component="img"
                        alt="https://media.cntraveler.com/photos/5a8ecbbc20dfb6552425e63e/16:9/w_2560,c_limit/Grandview-Beach_EJ6KK3.jpg"
                        height="140"
                        image="https://media.cntraveler.com/photos/5a8ecbbc20dfb6552425e63e/16:9/w_2560,c_limit/Grandview-Beach_EJ6KK3.jpg"
                        />
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12}>
                    {spotWaveConditions ? (
                    <Card className={classes.section} >
                        <CardCurrentConditions spot={spotWaveConditions}/>
                    </Card>
                    ) : (
                        <Skeleton variant="rectangular" width={210} height={118} />
                    )}
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Card sx={{ border: '1px solid silver' }} >
                        <CardContent>
                        <Collapse in={expanded} timeout="auto" unmountOnExit >
                                <div style={{ color: "grey", fontSize: 14, fontStyle: 'italic', fontWeight: 'bold', marginBottom: 10  }}>Analysis generated by AI:<br/></div>
                                
                                <Typography variant="body2" color="text.secondary">
                                    <span style={{ fontSize: 13 }}>{spotWaveConditions.wavesConditionsSummary}</span>
                                </Typography>
                            </Collapse>
                            <CardActions>
                                <Icon style={{ fontSize: 33 }}/>
                                <Button size="small" onClick={handleExpandClick}>{aiSectionText}</Button>
                            </CardActions>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12}>
                    {weather ? (
                    <Card className={classes.section}>
                        <CardCurrentWeatherConditions weather={weather}/>
                    </Card>
                    ) : (
                        <Skeleton variant="rectangular" width={210} height={118} />
                    )}
                </Grid>
                <Grid item xs={12} sm={12}>
                    {weatherWeek ? (
                    <Card className={classes.section}>
                        <WeatherWeek weekData={ weatherWeek } />
                    </Card>
                    ) : (
                        <Skeleton variant="rectangular" width={210} height={118} />
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Card className={classes.section}>
                        <ForecastChart forecast={forecast} chartTitle="Waves Forecast (Today)" waveStationForecast={waveStationForecast}  hAxisFormat='h' flagShowOnlyToday={true}/>
                    </Card>
                </Grid>
                
                <Grid item xs={12}>
                    <Card className={classes.section}>
                        <TideChart waterLevel={waterLevel}/>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card className={classes.section}>
                        <ForecastChart forecast={forecast} chartTitle="Waves Forecast (16 Days)" waveStationForecast={waveStationForecast} hAxisFormat='d' flagShowOnlyToday={false}/>
                    </Card>
                </Grid>
                
                <Grid item xs={12}>
                    <Card className={classes.sectionBlack}>
                        <CardContent>
                        <Typography className={classes.title}>
                        Nearby Buoys
                        </Typography>
                        </CardContent>
                        <CardActions>
                        <Button size="small" onClick={redirectToBuoysForeCast} variant="contained" endIcon={<BuoyForecastIcon />}>Forecast</Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default Forecast;
